import { __awaiter, __generator } from "tslib";
import { config } from '../config';
import { AppPageMode, EditorType, Origin, OriginQueryParam } from '..';
import { biLogger } from '../bi';
import { ModalNames } from '../components/modals/modals';
import { getAppPages, Origin as OriginMI, shouldShowAddAgain, } from '@wix/manage-installed-apps';
import { fetchInstalledApps } from '../api/api';
import { getReferralInfo, getWidgetReferral } from './bi-events';
import { BundleAppOrigin, AppGroup, } from '@wix/ambassador-marketplace/types';
export var openOrAddApp = function (app, marketplaceStore, biParams, configContext, experiments, updateInstalledApps, referral, referralTag) {
    var _a, _b;
    var appFromInstalled = getAppFromInstalled(marketplaceStore, app);
    var modalProps = getModalProps(app, marketplaceStore);
    var isInTestFlow = ((_a = marketplaceStore === null || marketplaceStore === void 0 ? void 0 : marketplaceStore.route) === null || _a === void 0 ? void 0 : _a.appPageMode) === AppPageMode.TEST;
    if (appFromInstalled) {
        handleAppFromInstalled(appFromInstalled, configContext);
    }
    else if (appNotSupportedInEditorX(app, experiments) && !isInTestFlow) {
        marketplaceStore.openModal(ModalNames.NOT_SUPPORTED_IN_EDITORX, modalProps);
    }
    else if (configContext.isMobile) {
        marketplaceStore.openModal(ModalNames.INSTALLATION_NOT_SUPPORTED_MOBILE, modalProps);
    }
    else if (appNotSupportedInAdi(app)) {
        marketplaceStore.openModal(ModalNames.SWITCH_TO_EDITOR, modalProps);
    }
    else if (siteNeedsUpgrade(app, marketplaceStore)) {
        marketplaceStore.openModal(ModalNames.UPGRADE_SITE, modalProps);
    }
    else if (siteNeedsDomain(app, marketplaceStore)) {
        marketplaceStore.openModal(ModalNames.CONNECT_DOMAIN, modalProps);
    }
    else {
        var appInstallationData = {
            appDefId: app.id,
            isPremiumApp: (_b = app === null || app === void 0 ? void 0 : app.pricing) === null || _b === void 0 ? void 0 : _b.isRequiredWixPremium,
            openMethod: app.openConsentIn,
            version: marketplaceStore.route.version,
            onInstallationSuccess: function (params) { return __awaiter(void 0, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            updateInstalledApps && updateInstalledApps();
                            // tslint:disable-next-line: no-floating-promises
                            return [4 /*yield*/, sendInstallationSuccessBi(app, params, biParams, marketplaceStore)];
                        case 1:
                            // tslint:disable-next-line: no-floating-promises
                            _a.sent();
                            return [2 /*return*/];
                    }
                });
            }); },
            onInstallationFail: function (params) { return __awaiter(void 0, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: 
                        // tslint:disable-next-line: no-floating-promises
                        return [4 /*yield*/, sendInstallationFailBi(app, params, biParams)];
                        case 1:
                            // tslint:disable-next-line: no-floating-promises
                            _a.sent();
                            return [2 /*return*/];
                    }
                });
            }); },
            goToManageApps: config.goToManageApps,
        };
        config.installApp(appInstallationData);
    }
};
function siteNeedsUpgrade(app, marketplaceStore) {
    var _a;
    return ((_a = app === null || app === void 0 ? void 0 : app.pricing) === null || _a === void 0 ? void 0 : _a.isRequiredWixPremium) && !marketplaceStore.siteIsPremium;
}
function siteNeedsDomain(app, marketplaceStore) {
    var _a;
    return ((_a = app === null || app === void 0 ? void 0 : app.pricing) === null || _a === void 0 ? void 0 : _a.isRequiredWixPremium) && !marketplaceStore.siteHasDomain;
}
function getModalProps(app, marketplaceStore) {
    return {
        appName: app.name,
        appId: app.id,
        appIcon: app.icon,
        msid: marketplaceStore.metaSiteId,
    };
}
export var finishInstallCTA = function (appDefId, appVersion, installedApps, configContext, shouldInstall) { return __awaiter(void 0, void 0, void 0, function () {
    var isAppOnStage, _a, appFromInstalled, isInstalledPageApp, isInstalledAddOnlyOnceApp;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                if (!configContext.isAppOnStage) return [3 /*break*/, 2];
                return [4 /*yield*/, configContext.isAppOnStage(appDefId)];
            case 1:
                _a = _b.sent();
                return [3 /*break*/, 3];
            case 2:
                _a = false;
                _b.label = 3;
            case 3:
                isAppOnStage = _a;
                appFromInstalled = installedApps &&
                    installedApps.find(function (installedApp) { return installedApp.webSolutionBase.id === appDefId; });
                isInstalledPageApp = isAppOnStage && getAppPages(appFromInstalled).length;
                isInstalledAddOnlyOnceApp = isAppOnStage &&
                    !shouldShowAddAgain(appFromInstalled, convertOriginToOriginMI(config.origin));
                if (isInstalledPageApp ||
                    (isInstalledAddOnlyOnceApp && configContext.closeMarket)) {
                    configContext.closeMarket();
                    return [2 /*return*/];
                }
                if (shouldInstall && configContext.finishAppInstall) {
                    configContext.finishAppInstall(appDefId, appVersion);
                }
                return [2 /*return*/];
        }
    });
}); };
export var convertOriginToOriginMI = function (origin) {
    if (origin === Origin.EDITOR) {
        return OriginMI.EDITOR;
    }
    return OriginMI.BIZMGR;
};
export var getInstalledApps = function (signedInstance) { return __awaiter(void 0, void 0, void 0, function () {
    var installedApps;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, fetchInstalledApps(signedInstance)];
            case 1:
                installedApps = _a.sent();
                // @ts-ignore
                return [2 /*return*/, ((installedApps && installedApps.filter(function (app) { return app.webSolutionBase; })) || [])];
        }
    });
}); };
export var mapOriginToQueryParam = function (route) {
    if (config.editorType === EditorType.ADI) {
        return OriginQueryParam.ADI_DASHBOARD;
    }
    var originMap = new Map([
        [Origin.BIZMGR, OriginQueryParam.BIZMGR],
        [Origin.EDITOR, OriginQueryParam.EDITOR],
        [Origin.STANDALONE, OriginQueryParam.STANDALONE],
    ]);
    var platform = route && route.platformName
        ? route.platformName
        : originMap.get(config.origin);
    return platform;
};
var cannotOpenEditorX = function (app, experiments) {
    if (experiments.enabled("specs.marketplace.editorx-for-" + app.id)) {
        return false;
    }
    return !isSolutionInTag(app, 'supported-by-editorx');
};
var isSolutionInTag = function (app, slug) {
    var _a;
    if ((_a = app === null || app === void 0 ? void 0 : app.Tags) === null || _a === void 0 ? void 0 : _a.length) {
        var res = app === null || app === void 0 ? void 0 : app.Tags.filter(function (tag) { return tag.slug === slug; });
        return res.length > 0;
    }
    return false;
};
function getAppFromInstalled(marketplaceStore, app) {
    var _a;
    return (_a = marketplaceStore === null || marketplaceStore === void 0 ? void 0 : marketplaceStore.installedApps) === null || _a === void 0 ? void 0 : _a.find(function (installedApp) { return installedApp.webSolutionBase.id === app.id; });
}
function handleAppFromInstalled(appFromInstalled, configContext) {
    if (!shouldShowAddAgain(appFromInstalled, convertOriginToOriginMI(config.origin)) &&
        configContext.openApp) {
        configContext.openApp(appFromInstalled);
    }
    else if (configContext.finishAppInstall) {
        configContext.finishAppInstall(appFromInstalled.webSolutionBase.id, appFromInstalled.installedVersion);
    }
}
function appNotSupportedInEditorX(app, experiments) {
    return (config.editorType === EditorType.EDITORX &&
        cannotOpenEditorX(app, experiments) &&
        (!experiments ||
            (experiments &&
                !experiments.enabled('specs.marketplace.editorXShowAllApps'))));
}
function appNotSupportedInAdi(app) {
    return (config.origin === Origin.BIZMGR &&
        config.editorType === EditorType.ADI &&
        !isSolutionInTag(app, 'adi-in-bm') &&
        !isSolutionInTag(app, 'adi-in-editor'));
}
function sendInstallationSuccessBi(app, params, biParams, marketplaceStore) {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_j) {
            switch (_j.label) {
                case 0: return [4 /*yield*/, biLogger.appMarketAppInstallationSuccess({
                        app_id: app.id,
                        esi: config.esi || '',
                        instance_id: params === null || params === void 0 ? void 0 : params.instance_id,
                        app_subcategory: biParams.subCategory,
                        tag_name: biParams.tagName,
                        tag_type: biParams.tagType,
                        section: biParams.section,
                        referral_info: getReferralInfo((_a = marketplaceStore === null || marketplaceStore === void 0 ? void 0 : marketplaceStore.route) === null || _a === void 0 ? void 0 : _a.referral, marketplaceStore === null || marketplaceStore === void 0 ? void 0 : marketplaceStore.prevRoute),
                        search_term: biParams.searchTerm,
                        widget_referral: getWidgetReferral(),
                        msid: params.msid,
                        referral_section_index: (_b = marketplaceStore === null || marketplaceStore === void 0 ? void 0 : marketplaceStore.route) === null || _b === void 0 ? void 0 : _b.appIndex,
                        referral_section_name: ((_c = marketplaceStore === null || marketplaceStore === void 0 ? void 0 : marketplaceStore.route) === null || _c === void 0 ? void 0 : _c.referralSectionName) ? (_d = marketplaceStore === null || marketplaceStore === void 0 ? void 0 : marketplaceStore.route) === null || _d === void 0 ? void 0 : _d.referralSectionName : (_e = marketplaceStore === null || marketplaceStore === void 0 ? void 0 : marketplaceStore.route) === null || _e === void 0 ? void 0 : _e.referral,
                        slug_id: (_f = marketplaceStore === null || marketplaceStore === void 0 ? void 0 : marketplaceStore.route) === null || _f === void 0 ? void 0 : _f.referralSectionName,
                        referral_tag_name: (_g = marketplaceStore === null || marketplaceStore === void 0 ? void 0 : marketplaceStore.route) === null || _g === void 0 ? void 0 : _g.referralTag,
                        collimp_id: (_h = marketplaceStore === null || marketplaceStore === void 0 ? void 0 : marketplaceStore.route) === null || _h === void 0 ? void 0 : _h.collimp_id,
                    })];
                case 1:
                    _j.sent();
                    return [2 /*return*/];
            }
        });
    });
}
function sendInstallationFailBi(app, params, biParams) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, biLogger.appMarketAppInstallationFailedClient({
                        app_id: app.id,
                        esi: config.esi || '',
                        instance_id: params && params.instance_id,
                        fail_reason: params && params.reason,
                        app_subcategory: biParams.subCategory,
                        tag_name: biParams.tagName,
                        tag_type: biParams.tagType,
                    })];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
}
export var shouldRenderAsLink = function () {
    if (config.origin === Origin.STANDALONE) {
        return 'link';
    }
};
export var isBrowser = function () { return typeof window !== 'undefined'; };
export var isBundleAppAndInstalled = function (appID, bundleApps) {
    var bundleApp = bundleApps && bundleApps.find(function (app) { return app.webSolutionBase.id === appID; });
    return (bundleApp &&
        bundleApp.group === AppGroup.BUNDLE &&
        bundleApp.upgradeSuggestion);
};
export var isBundleAppAndNotInstalled = function (appID, bundleApps) {
    var bundleApp = bundleApps && bundleApps.find(function (app) { return app.webSolutionBase.id === appID; });
    return (bundleApp &&
        bundleApp.group === AppGroup.BUNDLE &&
        !bundleApp.upgradeSuggestion);
};
export var isBundleAppWithVoucher = function (appID, bundleApps) {
    var bundleApp = bundleApps && bundleApps.find(function (app) { return app.webSolutionBase.id === appID; });
    return (bundleApp &&
        bundleApp.group === AppGroup.BUNDLE &&
        bundleApp.appOrigin === BundleAppOrigin.VOUCHER);
};
export var getBundleAppSavedPrice = function (appID, bundleApps) {
    var bundleApp = bundleApps && bundleApps.find(function (app) { return app.webSolutionBase.id === appID; });
    return bundleApp && bundleApp.appSavedPrice;
};
export var isWixApp = function (companyId) {
    return companyId === 'ad147a73-a40e-4e50-8344-2ad33592790d' || companyId === 'a60ac714-5c5a-4c38-a285-573752f04876';
};
export var wixChatBotLink = 'https://www.wix.com/support/conversations/category/contact';
export var isAppInstalled = function (appId, marketplaceStore) {
    var _a;
    return !!(marketplaceStore.installedApps &&
        ((_a = marketplaceStore.installedApps) === null || _a === void 0 ? void 0 : _a.findIndex(function (installedApp) { return installedApp.webSolutionBase.id === appId; })) > -1);
};
export var sortSolutionsByInstalled = function (solutions) {
    return solutions
        .filter(function (solution) { return !(solution === null || solution === void 0 ? void 0 : solution.isInstalled); })
        .concat(solutions.filter(function (solution) { return solution === null || solution === void 0 ? void 0 : solution.isInstalled; }));
};
export var getBadgeKeyFromTags = function (tags, experiments) {
    if ((experiments === null || experiments === void 0 ? void 0 : experiments.enabled('specs.marketplace.blackFridaySale')) &&
        (tags === null || tags === void 0 ? void 0 : tags.findIndex(function (tag) { return tag.slug === 'pre-holiday-sale'; })) > -1) {
        return 'solutionPage.badge.holidaySale';
    }
    return '';
};
export var getBadgeTheme = function (key) {
    if (key === 'solutionPage.badge.holidaySale') {
        return {
            type: 'solid',
            size: 'small',
            uppercase: true,
        };
    }
};
//# sourceMappingURL=utils.js.map